import { httpGet, httpPost } from '../../../utils/api.utils';
import { CSAT_SETTINGS } from "../../../constants/external-constants";

import {
    setCsatQuestions,
    setCsatLoading,
    setSurveyModel,
    setSurveyComment,
    setDisableSubmit,
    showHideCsatModal,
    showCompletion,
    resetInitialState,
    showCSATButton,
    setCsatSurvey
} from '../../../constants/model-reducers/external/csat-survey/csat-survey.settings'



const defaultState = () => ({
    requestTypescsat: {},
    csatQuestions: [],
    surveyModel: [],
    isLoading: true,
    disableSubmit: true,
    isShow: false,
    isShowCompletion: false,
    showCSATButton: false
});

const initialState = defaultState();

export const csatActions = {
    fetchCsatQuestions: e => async dispatch => {
        var employeeId = JSON.parse(sessionStorage.getItem('User')).Employee.EmployeeId;
        dispatch({ type: setCsatLoading, isLoading: true })
        var data = await httpGet('external/requestdetail/getCsatQuestions?employeeId=' + employeeId);
        var rates = await httpGet('external/requestdetail/getCsatRateTypes?employeeId=' + employeeId);
        dispatch({
            type: setCsatQuestions,
            data: getRandom(data, CSAT_SETTINGS.questionCount),
            rates: rates,
            isLoading: false,

        });
    },

    fetchCsatSurvey: (item) => async (dispatch, state) => {
        var employeeId = JSON.parse(sessionStorage.getItem('User')).Employee.EmployeeId;
        var orderId = item != null || Object.keys(item).length > 0 ? item.OrderId : 0;
        var data = await httpGet(
            'external/requestDetail/GetOrderSurvey?orderId=' + orderId + '&employeeId=' + employeeId
        );
        dispatch({
            type:setCsatSurvey,
            survey: data
        })
    },

    setCsatFormData: (e, question) => async (dispatch, state) => {
        const target = e.target;
        const id = e.target.id;
        const value = e.target.value;
        const element = e.target.tagName;
        const type = e.target.type;
        const surveyModel = state().csatSurveyRequest.surveyModel;

        if (element === 'INPUT') {
            if (type === 'radio') {
                //Remove from model if existing
                var index = surveyModel.map(x => x.questionID).indexOf(parseInt(question.QuestionId));
                if (index !== -1) {
                    surveyModel.splice(index, 1);
                }

                //Add to model
                surveyModel.push({
                    questionID: question.QuestionId,
                    rate: value,
                    comment: null
                });
            }
        } else if (element === 'TEXTAREA' && id === 'csat-comment') {
            var index = surveyModel.map(x => x.questionID).indexOf(parseInt(1));
            if (index !== -1) {
                surveyModel.splice(index, 1);
            }
            surveyModel.push({
                questionID: 1,
                rate: "0",
                comment: value
            });

        }

        dispatch({
            type: setSurveyModel,
            data: surveyModel,
        });
        if ((surveyModel.filter(x => x.questionID != 1).length) == CSAT_SETTINGS.questionCount) {
            dispatch({ type: setDisableSubmit, data: false })
        }

    },

    handleShowCompletion: (e) => async dispatch => {
        dispatch({ type: showCompletion, isShow: true })
    },

    resetShowCompletion: (e) => async dispatch => {
        dispatch({ type: showCompletion, isShow: false })
    },

    submitCsat: (e) => async (dispatch, state) => {
        var orderId = state().requestDetail.requestData.Order.OrderId;
        var model = state().csatSurveyRequest.surveyModel;
        var data = {
            OrderId: orderId,
            EmployeeId: sessionStorage.EmployeeID,
            EmployeeName: sessionStorage.FirstName + " " + sessionStorage.MiddleInitial + " " + sessionStorage.LastName,
            CsatOrderModel: model
        }
        if (model.length >= 4 && orderId != null) {
            return await httpPost('external/requestdetail/submitCsat', data);
        } else {
            alert("Error encountered while saving.")
        }

    },

    resetCsatToInitial: () => (dispatch, state) => {
        var newInitial = defaultState();
        dispatch({ type: resetInitialState, data: newInitial });
    },

    handleShowSurvey: (e) => async dispatch => {
        dispatch({ type: showHideCsatModal, isShow: true })
    },

    handleHideSurvey: (e) => async dispatch => {
        dispatch({ type: showHideCsatModal, isShow: false })
    },

    isShowSurvey: (item, surveyCompleted) => async (dispatch, state) => {
        var isShow;

        if (!surveyCompleted) {
            var orderId = item != null || Object.keys(item).length > 0 ? item.OrderId : 0;
            var employeeId = JSON.parse(sessionStorage.getItem('User')).Employee.EmployeeId;
            isShow = await httpGet(
                'external/requestDetail/isShowSurvey?orderId=' + orderId + '&employeeId=' + employeeId
            );
        } else {
            isShow = false;
        }
        dispatch({ type: showCSATButton, showCSATButton: isShow });
    }
};

function getRandom(arr, n) {
    var result = new Array(n),
        len = arr.length,
        taken = new Array(len);
    if (n > len)
        throw new RangeError("getRandom: more elements taken than available");
    while (n--) {
        var x = Math.floor(Math.random() * len);
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
    }
    return result;
}

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case setCsatQuestions:
            return {
                ...state,
                csatQuestions: action.data,
                csatRateTypes: action.rates,
                isLoading: action.isLoading
            };
        case setCsatSurvey:
            return {
                ...state,
                csatSurvey: action.survey
            }
        case setCsatLoading:
            return {
                ...state,
                isLoading: action.isLoading
            };
        case setSurveyModel:
            return {
                ...state,
                surveyModel: action.data,
            };
        case setDisableSubmit:
            return {
                ...state,
                disableSubmit: action.data
            };
        case showHideCsatModal:
            return {
                ...state,
                isShow: action.isShow,
                surveyModel: [],
                disableSubmit: true
            };
        case showCompletion:
            return {
                ...state,
                isShowCompletion: action.isShow
            };
        case resetInitialState:
            return {
                ...state,
                ...action.data
            };
        case showCSATButton:
            return {
                ...state,
                showCSATButton: action.showCSATButton
            };
        default:
            return state;
    }
};
